module.exports = __webpack_public_path__ + "img/未标题-7.7145bedb.jpg";